import React from 'react';
import PropTypes from 'prop-types';
import { useUserAdmin } from '../admin/UserContext';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { createTheme } from '@mui/material/styles';
import { AppProvider } from '@toolpad/core/AppProvider';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { Card, CardContent } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import WebIcon from '@mui/icons-material/Web';
import { useTheme } from '@mui/material/styles';
import "../css/Login/BotonCerrarSecion.css"
import Logo from"../Image/Logo.png"
import CodeIcon from '@mui/icons-material/Code';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import StarIcon from '@mui/icons-material/Star';

function SuperAdminSP({ children }) {


  const demoTheme = createTheme({
    palette: {
      mode: 'dark',
      background: { default: '#ffff', paper: '#2C445F' },
      text: { primary: '#ffffff', secondary: '#B0B0B0', fontSize: '0.9rem' },
    },
    typography: {
      fontFamily: 'Montserrat',
      body1: { color: '#585857', fontSize: '0.8rem' },
      body2: { color: '#585857' },
    },
    components: {
      MuiSvgIcon: { styleOverrides: { root: { color: '#ffffff' } } },
      MuiTypography: { styleOverrides: { root: { color: '#ffffff' } } },
      MuiAppBar: {
        styleOverrides: {
          root: {
            '.css-yzjoij': { display: 'none' },
            '.MuiTypography-root': { display: 'none' },
          },
        },
      },
    },
    breakpoints: { values: { xs: 0, sm: 600, md: 600, lg: 1200, xl: 1536 } },
  });



  const NAVIGATION = [
    { segment: 'inicio/administrador', title: 'Inicio', icon: <HomeIcon /> },
     {
    
    title: 'Pagina Inicio',
    icon: <WebIcon />,
    children: [
      {
        segment: 'administrador/Portada/pagina/Inicio',
        title: 'Portada Slider',
        icon: <CodeIcon  />,
      },
     
      {
        segment:'administrador/servicio/pagina/Inicio',
        title: 'Servicio Inicio',
        icon: <CodeIcon  />,
      },
      {
        segment:'administrador/porcentaje/admin',
        title: 'porcentaje Inicio',
        icon: <CodeIcon  />,
      }
      
     
    ],
  },
  {
    
    title: 'Pagina Nosotros',
    icon: <WebIcon />,
    children: [
      {
        segment: 'administrador/portadanosotros/admin',
        title: 'Portada Nosotros',
        icon: <CodeIcon  />,
      },
     
      {
        segment:'administrador/josemar/admin',
        title: 'Sesión Josemar',
        icon: <CodeIcon  />,
      },
      {
        segment:'administrador/icono/admin',
        title: 'Sesión icono Josemar',
        icon: <CodeIcon  />,
      }
      
     
    ],
  },
     {
        segment:'administrador/Producto/pagina/Inicio',
        title: 'Categoria de productos',
        icon: <CodeIcon  />,
      },

      {
        segment:'administrador/productos/pagina/Inicio',
        title: 'Productos',
        icon: <CodeIcon  />,
      },
   
       {
        segment:'administrador/reporte',
        title: 'Reporte Productos',
        icon: <StarIcon  />,
      },
       {
        segment:'administrador/correo',
        title: 'Correos',
        icon: <EmailOutlinedIcon  />,
      },

  ];


  return (
    <AppProvider navigation={NAVIGATION} theme={demoTheme}>
      <DashboardLayout defaultSidebarCollapsed>
        <SidebarHeader />
        {children}
      
      </DashboardLayout>
    </AppProvider>
  );
}

SuperAdminSP.propTypes = {
  children: PropTypes.node.isRequired,
  window: PropTypes.func,
};

export default SuperAdminSP;

export const SidebarHeader = () => {
  const { Usuario } = useUserAdmin();
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', padding: '16px', width: '100%' }}>
      <Card sx={{ display: 'flex', alignItems: 'center', justifyContent: "flex-start", width: '100%' }}>
        <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: "flex-start", width: '100%' }}>
          <Box sx={{
            width:'200px'
          }}>
            <img src={Logo} alt="hod" style={{width:'100%', height:'auto'}} />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', width:'400px' }}>
            <Typography variant="h5" className="TituloBienvenidoEmpresaAdmi" sx={{
              color: theme.palette.mode === 'light' ? '#ffff' : '#FFFFFF', fontFamily: 'Montserrat', fontWeight: '600'
            }}>Bienvenido</Typography>
            <Typography variant="h6" className="NombreBienvenidoEmpresaAdmi" sx={{
              color: theme.palette.mode === 'light' ? '#ffff' : '#FFFFFF', fontFamily: 'Montserrat', fontWeight: '500'
            }}>HOD {Usuario.name}</Typography>
          </Box>
          <FootterLayout/>
        </CardContent>
      </Card>
    </Box>
  );
};

export const FootterLayout = () => {
  const { logout } = useUserAdmin();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '16px', width: '100%' }}>
      <button className="Botoncerrarseccionempresa" onClick={logout}>
        <div className="ContieneBotonCerrarSecionEmpresa">
          <svg viewBox="0 0 512 512">
            <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z">
            </path>
          </svg>
        </div>
        <div className="TextoBotonCerrarSecionEmpresa">Cerrar Sesión</div>
      </button>

    </Box>
  )
}